import { Box, Typography } from '@mui/material'
import { PropsStep2 } from './types'
import { ActivityForm } from '../activityForm'
import { CustomTable } from '../../../../../../../../../../components'
import { useStyles } from './styles'
import { useEffect } from 'react'

export const Step2 = (props: PropsStep2) => {
  const styles = useStyles()

  const handleSelects = (value: number[]) => {
    const checks = value.filter((checkId: number) => !props.disabledUsers.some(disableId => disableId == checkId))
    props.setUsersSelectedInActivity(checks)
  }


  useEffect(()=>{
    if(!props.table.row.length){
      props.handleSteps(1)
    }
  },[props.table.row.length])

  return (
    <Box /* sx={styles.filterContainer} */>
      <Box sx={styles.body}>
        <Box sx={{ display: 'flex' }}>
          <Typography sx={styles.title}>{props.t('loogbook.titles.activityByUserSettings')}</Typography>
        </Box>
        <CustomTable
          name={'Table'}
          tableChecks
          dontRefresh
          column={props.table.column}
          row={props.table.row}
          defaultChecks={props.usersSelectedInActivity}
          disabledChecks={props.disabledUsers}
          onClick={(e) => { handleSelects(e.checks ?? []) }}
          selected={-1}
          loader={props.loading.subtmitActivity}
          /* defaulPagination={20} */
        />

      </Box>

      <ActivityForm 
        inputActivity={props.inputActivity} 
        activities={props.activities} 
        open={props.open} 
        inputActivityCheck={props.inputActivityCheck}
        setOpen={props.setOpen} 
        handleActivities={props.handleActivities} 
        deleteActivity={props.deleteActivity} 
        editActivity={props.editActivity} 
        inputFilterUnity={props.inputFilterUnity} 
        table={props.tableUnits} 
        filterUnity={props.filterUnity} 
        loading={props.loading} 
        totalPages={props.totalPages}
        destination={props.destination}
        setDestination={props.setDestination}
        destinationFinal={props.destinationFinal}
        setDestinationFinal={props.setDestinationFinal}
        setUnityToDestination={props.setUnityToDestination}
        inputDestination={props.inputDestination}
        allUsers={props.allUsers}
        assignActivities={props.assignActivities}
        handleRowClickUnity={props.handleRowClickUnity}
        setInputActivity={props.setInputActivity}
        typeActivityOpen={props.typeActivityOpen}
        companies={props.companies}
        editActivityDestination={props.editActivityDestination}
        localRegister={props.localRegister}
        setLocalRegister={props.setLocalRegister}
        destinatioCreated={props.destinatioCreated}
      />
    </Box>
  )
}